module.exports = __webpack_public_path__ + "img/clock-rotate-left-orange.4480e5e6.svg";